import styled from 'styled-components';
import StyledMobileNavLink from 'components/appbar/mobile/StyledMobileNavLink';

const SecondaryNavLink = styled(StyledMobileNavLink)`
  width: 100%;
  height: 100%;
  font-weight: unset;
  line-height: 20px;
  line-height: 18px;
  word-break: break-word;
`;

export default SecondaryNavLink;
